import { faExternalLink } from '@fortawesome/free-solid-svg-icons'
import React, { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate, Link } from 'react-router-dom'
import { AccessLevel } from '../../../queries/types'
import {
  Content,
  Data,
  Button,
  Indicators,
  Layout,
  Navigation,
  Responsive,
} from 'ui'
import { profileForUser, profileUrlForUser } from './helpers'
import { usePaginatedRoles } from './usePaginatedRoles'
import { AccessLevelInput, useAccessLevelFilters } from './AccessLevelFilters'

const { Table, Cell, Row, Header } = Data

interface IParams {
  accessLevel: AccessLevel
}

const UsersListView: React.FC = () => {
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('expanded')
  const navigate = useNavigate()
  const handleNewUser = () => {
    navigate('/admin/roles/user/new')
  }

  const { accessLevel } = useAccessLevelFilters()
  const { loading, error, users } = usePaginatedRoles()

  return (
    <Layout.PaddedContent>
      <Helmet>
        <title>Roles: {accessLevel} - MCSS Pro Connect</title>
      </Helmet>
      <div className="flex-col flex w-full">
        <div className="flex flex-col gap-3 mb-3 md:flex-row md:items-end md:justify-between">
          <Content.Heading>User Roles</Content.Heading>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end">
            <div className="w-full sm:w-64 md:w-72">
              <AccessLevelInput />
            </div>
            <div className="sm:w-auto">
              <Button onClick={handleNewUser}>
                <span>New Admin</span>
              </Button>
            </div>
          </div>
        </div>
        <Table>
          <Row>
            <Header
              width="50%"
              className="bg-contentareabackground !text-secondary"
            >
              Email
            </Header>
            <Header
              width="30%"
              className="bg-contentareabackground !text-secondary"
            >
              Profile
            </Header>
            <Header
              width="10%"
              className="bg-contentareabackground !text-secondary"
            >
              &nbsp;
            </Header>
          </Row>
          {loading ? (
            <Row>
              <Indicators.Spinner size="2x" className="m-auto" />
            </Row>
          ) : users.length > 0 ? (
            users.map((u, i) => (
              <Row key={u?.id ?? `user${i}`}>
                <Cell width="50%">{u?.emailAddress}</Cell>
                <Cell width="30%">
                  <Link to={profileUrlForUser(u)}>{profileForUser(u)}</Link>
                </Cell>
                <Cell width="10%">
                  <Navigation.IconLink
                    icon={faExternalLink}
                    to={`/admin/roles/user/${u?.id}`}
                  />
                </Cell>
              </Row>
            ))
          ) : error ? (
            <div className="text-red-500 text-sm">
              {error
                ? error.message
                : 'There was a problem fetching user profiles.'}
            </div>
          ) : (
            <Row>
              <Cell>No results found.</Cell>
            </Row>
          )}
        </Table>
      </div>
    </Layout.PaddedContent>
  )
}

export const AdminRolesListView = UsersListView
